/**
 * @generated SignedSource<<5f65573e9e227e41fd03c2ff72680ff0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CommunityInitializeMutation$variables = {
  aaid?: string | null;
  emailId?: string | null;
};
export type CommunityInitializeMutation$data = {
  readonly unified: {
    readonly community: {
      readonly initializeCommunity: {
        readonly errors: ReadonlyArray<{
          readonly code: string | null;
          readonly extensions: {
            readonly errorType: string | null;
            readonly statusCode: number | null;
          } | null;
          readonly message: string | null;
        }> | null;
        readonly forumsProfile: {
          readonly id: string;
        } | null;
        readonly gamificationProfile: {
          readonly userId: string | null;
        } | null;
        readonly success: boolean;
        readonly unifiedProfile: {
          readonly aaid: string | null;
          readonly accountInternalId: string | null;
          readonly id: string;
          readonly internalId: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type CommunityInitializeMutation = {
  response: CommunityInitializeMutation$data;
  variables: CommunityInitializeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aaid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "emailId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UnifiedMutation",
    "kind": "LinkedField",
    "name": "unified",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedCommunityMutation",
        "kind": "LinkedField",
        "name": "community",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "aaid",
                "variableName": "aaid"
              },
              {
                "kind": "Variable",
                "name": "emailId",
                "variableName": "emailId"
              }
            ],
            "concreteType": "UnifiedCommunityPayload",
            "kind": "LinkedField",
            "name": "initializeCommunity",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedMutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedMutationErrorExtension",
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "errorType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "message",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedForumsAccount",
                "kind": "LinkedField",
                "name": "forumsProfile",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "success",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedGamificationProfile",
                "kind": "LinkedField",
                "name": "gamificationProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedProfile",
                "kind": "LinkedField",
                "name": "unifiedProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aaid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountInternalId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "internalId",
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommunityInitializeMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommunityInitializeMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "6053cdab7b073d23091bceae14e9497a",
    "id": null,
    "metadata": {},
    "name": "CommunityInitializeMutation",
    "operationKind": "mutation",
    "text": "mutation CommunityInitializeMutation(\n  $aaid: String\n  $emailId: String\n) {\n  unified {\n    community {\n      initializeCommunity(aaid: $aaid, emailId: $emailId) {\n        errors {\n          code\n          extensions {\n            errorType\n            statusCode\n          }\n          message\n        }\n        forumsProfile {\n          id\n        }\n        success\n        gamificationProfile {\n          userId\n        }\n        unifiedProfile {\n          aaid\n          accountInternalId\n          internalId\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3946027750118d9a2d99f456520322fb";

export default node;
